import { useQuery } from "@tanstack/react-query";
import { canUse, getPlanLabel, type PlanTier, type FeatureKey } from "@adresflow-v2/shared";
import { fetchRailway } from "@/lib/apiClient";

async function fetchPlan(): Promise<PlanTier> {
  const res = await fetchRailway("/v1/me/plan");
  if ("error" in res) throw new Error(res.error);
  return ((res as { data?: { tier?: string } }).data?.tier as PlanTier) ?? "free";
}

export function usePlan() {
  const { data: tier = "free", isLoading, isError } = useQuery({
    queryKey: ["me-plan"],
    queryFn: fetchPlan,
    staleTime: 5 * 60_000,
    retry: 2,
  });

  return {
    tier,
    label: getPlanLabel(tier),
    isLoading,
    isError,
    canUse: (feature: FeatureKey) => canUse(feature, tier),
  };
}
